import { AGGREGATE_NAMES } from 'cpool-constants';
import type { SchemaUserResolver_GetAclPermissions } from 'cpool-tables/backend-resolvers';
import { getAddedAdvisorId, type LeadAssignment } from 'cpool-utils';

// shared non-IK lead: changeAssignedUser is granted only to the added advisor's side (advisor or their delegate)
export const canHandOnAddedAdvisorShare = ({
    lead,
    permissions,
}: {
    lead: LeadAssignment;
    permissions?: SchemaUserResolver_GetAclPermissions;
}) => !!getAddedAdvisorId(lead) && !!permissions?.commands[AGGREGATE_NAMES.LOAN_REQUEST].changeAssignedUser;
